<template>
  <div class="hello">
    <div class="bg">
      <div class="footer" ref="footer">
        <div class="title">
          <span>{{$t('language.Account')}}</span>
        </div>
        <div class="line"></div>
        <div class="navBar">
          <div class="leftNav">
            <span>{{$t('language.personal')}}</span>
          </div>

        </div>
        <div class="bod">
          <div class="uploadFile" style="margin-left: 175px;">
            <div class="uploadLeft">
              <img :src="uploadImage" alt="">
            </div>
            <input ref="filElem" type="file" class="upload-file" @change="getFile" style="display: none;">
            <div class="upload" @click="choiceImg">
              <span>{{this.$t('language.uploadHead')}}</span>
            </div>
          </div>
          <div class="label" v-for="(item,index) in labelList" :key="index">
            <div class="tabl">
              <span>{{item.name}}</span>
            </div>
            <div class="labelContent">
              <el-input v-model="item.value"></el-input>
            </div>
          </div>
          <div class="submitB" @click="submitOn()">
            <span>{{$t('language.submit')}}</span>
          </div>
        </div>
        <div class="bgsubmit" @click="closeLogin">
          <span>{{$t('language.out')}}</span>
        </div>
        <div style="height: 50px;"></div>
        <fiex :shows="fixed" :fatherMethod="goTop" ref="fiex"></fiex>
      </div>

    </div>
  </div>
</template>

<script>
  import fiex from '../components/fiex.vue'
  export default {
    components: {
      fiex
    },
    data() {
      return {
        fixed: true,
        imageUrl: require('../assets/image/banner1.png'),
        uploadImage: '',
        fileList: [],
        update: [{
            name: '原密码',
            value: ''
          },
          {
            name: '新密码',
            value: ''
          },
          {
            name: '确认密码',
            value: ''
          }
        ],
        labelList:[],
        value: '',
        avatar:''
      }
    },
    computed:{

    },
    created(){
      this.labelList = [{
            name: this.$t('language.yourname'),
            value: ''
          },
          {
            name: this.$t('language.idcard'),
            value: ''
          },
          {
            name: this.$t('language.email'),
            value: ''
          },
          {
            name: this.$t('language.address'),
            value: ''
          }
        ];
      this.$fetch('/User/info').then(res=>{
        this.labelList[0].value = res.data.truename;
        this.labelList[1].value = res.data.idcard;
        this.labelList[2].value = res.data.email;
        this.labelList[3].value = res.data.address;
         this.uploadImage = res.data.avatar;
      })
    },
    methods: {
      goTop(){
        this.$refs.footer.scrollTop = 0;
      },
      getFile(el) {
        var file = el.target.files[0];
        var blob = new Blob([file]);

        const blobUrl = window.URL.createObjectURL(blob);
        this.uploadImage = blobUrl;
        var formData = new FormData();
        formData.append('file',file);
         this.$post('/Upload/image',formData).then(res=>{
          if(res.code == 200){
            this.uploadImage = res.data.thumb_path;
            this.$message.success(this.$t('language.upload_success'));
          }
         })
      },
      choiceImg() {
        this.$refs.filElem.dispatchEvent(new MouseEvent('click'))
      },
      closeLogin(){
        localStorage.removeItem('expires_in');
        localStorage.removeItem('userInfo');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');
        this.$router.push('/')
        window.location.reload();
      },
      submitOn(){

        var userInfo = JSON.parse(localStorage.getItem('userInfo'));

        console.log(localStorage.getItem('userInfo'));
        if(this.uploadImage == ''){
          this.$message.error('请上传头像');
          return
        }
        var data = {
            avatar:this.uploadImage,
            truename:this.labelList[0].value,
            idcard:this.labelList[1].value,
            email:this.labelList[2].value,
            address:this.labelList[3].value
        }
        this.$post('/User/auth',data).then(res=>{
          if(res.code == 200){
            this.$message.success('保存成功')
            this.$router.push('/personal')
            userInfo['truename'] = this.labelList[0].value;
            userInfo['avatar'] = this.uploadImage;
            localStorage.setItem('userInfo',JSON.stringify(userInfo));
            window.location.reload();

          }
        })
      }
    }
  }
</script>

<style scoped="scoped">
  @import url("../assets/css/account.css");
</style>



// WEBPACK FOOTER //
// src/pages/account.vue